const resource = {
  "verificationNotify": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verification may take from 2 minutes to 6 hours"])},
  "statusForm": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verification failed"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Make sure the information meets the requirements and try again"])}
  },
  "retry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Try again"])}
}
export default resource